import {apiGet} from "@/services/api";
import {CityResponse} from "@/services/city/types";

export function index(): Promise<CityResponse>{
    return apiGet("/city/");
}